import flowLinksService from '../../libs/flowLinksService';

export default flowLinksService.getFlowLink;
